import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { permisopagina } from '../models/permisopagina';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { perfil } from '../models/perfil';
import { environment } from 'src/environments/environment';

const httpOption = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
  }),
};

@Injectable({
  providedIn: 'root'
})
export class ConfiguracionService {

  url = environment.baseUrl+ '/api/Configuracion/';

  constructor(private http: HttpClient) {}

  getDatosConfig(): Observable<any> {
    return this.http.post<any>(this.url+'GetDatosConfig', {}, httpOption);
  }
  
  guardarDatosConfig(obj:any): Observable<boolean> {
    return this.http.post<boolean>(this.url+'GuardarDatosConfig', obj, httpOption);
  } 

  getReglasEmpresa(): Observable<any> {
    return this.http.post<any>(this.url+'GetReglasEmpresa', {}, httpOption);
  } 
}
